import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StatisticalForecastingOverviewComponent } from './statistical-forecasting-overview.component';
import { DxDataGridModule, DxChartModule, DxTextAreaModule, DxRangeSelectorModule, DxPopupModule, DxSwitchModule } from 'devextreme-angular';
import { DevEpressCommonModule } from 'src/app/dev-epress-common.module';
import { StatisticalForecastingOverviewRoutingModule } from './statistical-forecasting-overview-routing.module';
import { BookmarkModule } from 'src/app/widgets/bookmark/bookmark.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DxTableControllerDirective } from 'src/app/directives/dx-table-controller.directive';
import { BookmarkNewComponent } from 'src/app/widgets/bookmark-new/bookmark-new.component';
import { FiltersGroupModule } from 'src/app/widgets/filters/filters-group/filters-group.module';
import { HelpButtonComponent } from 'src/app/widgets/help-button/help-button.component';
import { WebExportModule } from 'src/app/widgets/web-export/web.export.module';


@NgModule({
    declarations: [StatisticalForecastingOverviewComponent],
    imports: [
        CommonModule,
        DxChartModule,
        DxTextAreaModule, DxRangeSelectorModule,
        DxDataGridModule,
        DevEpressCommonModule,
        StatisticalForecastingOverviewRoutingModule,DxSwitchModule,
        DxPopupModule,BookmarkModule,DxPopupModule,FormsModule,ReactiveFormsModule,
		DxTableControllerDirective,FiltersGroupModule,HelpButtonComponent,BookmarkNewComponent,WebExportModule
    ]
})
export class StatisticalForecastingOverviewModule { }
